<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
<template>
  <v-card :loading="loading">
    <v-app-bar flat color="white">
      <v-toolbar-title class="font-weight-medium">
        {{ $capitalize($tc("model.productbudget_choose_product")) }}
      </v-toolbar-title>

      <v-spacer />
      <v-btn icon @click="handleClose" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-stepper
      style="max-width: 950px"
      class="elevation-0 mx-auto mt-3"
      v-model="current_step"
      non-linear
      v-if="availableSteps.length > 0 && !editMode"
    >
      <v-stepper-header>
        <template v-for="(step, index) in availableSteps">
          <v-stepper-step
            :step="index + 1"
            :key="'stepper' + index"
            :editable="step.editable"
          >
            {{ step.title }}
          </v-stepper-step>
          <v-divider
            :key="'divider' + index"
            v-if="index < availableSteps.length - 1"
          />
        </template>
      </v-stepper-header>
    </v-stepper>
    <v-row style="max-width: 950px" class="mx-auto">
      <v-col key="barcode" cols="12" v-if="showStep('barcode') && !editMode">
        <v-card-title
          ><v-icon left color="primary">mdi-barcode-scan</v-icon>
          {{ $capitalize($tc("model.productbudget_search")) }}</v-card-title
        >
        <v-card-text>
          <v-text-field
            :label="$capitalize($tc('model.productbudget_bar_code'))"
            name="barcode"
            :value="barcode"
            @change="barcode = $event"
            persistent-hint
            :hint="
              form_found_product.id || loading_autocomplete_barcode || !barcode
                ? ''
                : $capitalize($tc('model.productbudget_no_products_found'))
            "
            :disabled="loading || loading_autocomplete_barcode"
            :loading="loading_autocomplete_barcode"
            append-icon="mdi-upload"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-fade-transition>
          <div v-if="form_found_product.id">
            <v-card-title>
              <v-icon left color="primary">mdi-check</v-icon
              >{{ $capitalize($tc("model.productbudget_product_found")) }}
              <v-spacer />
              <v-btn icon @click="removeProduct"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text>
              <v-card dark outlined color="primary">
                <v-img
                  :src="form_found_product.photo_url"
                  v-if="$vuetify.breakpoint.xs"
                  height="150"
                >
                  <template v-slot:placeholder>
                    <v-overlay absolute>
                      <v-icon>mdi-image-off</v-icon>
                    </v-overlay>
                  </template>
                </v-img>
                <div class="d-flex flex-no-wrap justify-space-between">
                  <div>
                    <v-card-title class="headline">{{
                      foundProductName
                    }}</v-card-title>
                    <v-card-subtitle>
                      <div
                        v-for="feature in form_found_product.features"
                        :key="feature.id"
                        v-text="`${feature.name}: ${feature.pivot.value}`"
                      ></div>
                    </v-card-subtitle>
                  </div>

                  <v-avatar
                    class="ma-3"
                    size="150"
                    rounded
                    v-if="$vuetify.breakpoint.smAndUp"
                  >
                    <v-img :src="form_found_product.photo_url">
                      <template v-slot:placeholder>
                        <v-overlay absolute>
                          <v-icon>mdi-image-off</v-icon>
                        </v-overlay>
                      </template>
                    </v-img>
                  </v-avatar>
                </div>
              </v-card>
            </v-card-text>
          </div>
        </v-fade-transition>
        <v-card-actions v-if="!editMode">
          <v-spacer></v-spacer>
          <v-btn
            v-if="!editMode"
            @click="handleClose"
            text
            :disabled="loading"
            >{{ $capitalize($tc("model.productbudget_cancel_button")) }}</v-btn
          >
          <v-btn
            color="primary"
            text
            :disabled="loading"
            @click="nextStepAndSetProduct"
            >{{
              $capitalize($tc("model.productbudget_continue_button"))
            }}</v-btn
          >
        </v-card-actions>
      </v-col>
      <v-col
        key="local_category"
        cols="12"
        v-if="showStep('local_category') && !editMode"
      >
        <v-card-title
          ><v-icon left color="primary">mdi-shape</v-icon>
          {{
            $capitalize($tc("model.productbudget_product_types"))
          }}</v-card-title
        >
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="pr-2">
              <v-text-field
                v-model="filter_local_category"
                :placeholder="
                  $capitalize($tc('model.productbudget_search_type_product'))
                "
                outlined
                dense
                append-icon="mdi-magnify"
              />
            </v-col>
          </v-row>
          <v-virtual-scroll
            :bench="1"
            :items="chunked_categories"
            item-height="160"
            height="400"
          >
            <template v-slot="{ item }">
              <v-row dense no-gutters>
                <v-col
                  v-for="category in item"
                  :key="category.id"
                  class="d-flex child-flex pr-2"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                >
                  <v-card outlined @click="chooseLocalCategory(category)">
                    <v-img
                      aspect-ratio="1"
                      contain
                      :src="category.image_url"
                      style="cursor: pointer"
                      height="150"
                    >
                      <v-row align="end" class="lightbox pa-2 fill-height">
                        <v-col>
                          <div class="overline text-center">
                            <span
                              class="px-2 py-2"
                              style="background: rgba(255, 255, 255, 0.75)"
                            >
                              {{ category.name }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                      <v-overlay
                        v-if="category.id == form.local_category.id"
                        absolute
                        color="primary"
                      />
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-virtual-scroll>
        </v-card-text>
        <v-card-actions v-if="!editMode">
          <v-spacer></v-spacer>
          <v-btn text @click="current_step = current_step - 1">{{
            $capitalize($tc("model.productbudget_back_button"))
          }}</v-btn>
          <v-btn
            color="primary"
            text
            :disabled="loading"
            @click="current_step = current_step + 1"
            >{{
              $capitalize($tc("model.productbudget_continue_button"))
            }}</v-btn
          >
        </v-card-actions>
      </v-col>
      <v-col key="product" cols="12" v-if="showStep('product') || editMode">
        <v-form @submit.prevent="handleSubmitForm" class="product-form">
          <ValidationObserver ref="form" v-slot="{ invalid }">
            <v-card-title>
              <v-icon left color="primary">mdi-cart</v-icon>
              {{ $capitalize($tc("model.productbudget_product")) }}
            </v-card-title>
            <v-card-text>
              <ValidationProvider name="local_category" v-slot="{ errors }">
                <v-combobox
                  name="local_category"
                  :label="$capitalize($tc('model.productbudget_product_types'))"
                  v-model="form.local_category"
                  item-text="name"
                  item-value="id"
                  :items="local_categories"
                  :error-messages="errors"
                  :loading="loading_local_categories"
                  :disabled="loading || loading_local_categories"
                  return-object
                />
              </ValidationProvider>
              <ValidationProvider name="barcode" v-slot="{ errors }">
                <v-text-field
                  :label="$capitalize($tc('model.productbudget_bar_code'))"
                  name="barcode"
                  v-model="form.barcode"
                  persistent-hint
                  :error-messages="errors"
                  :disabled="loading"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="brand"
                rules="required"
                v-slot="{ errors }"
              >
                <v-combobox
                  :label="$capitalize($tc('model.productbudget_brand'))"
                  v-model="form.brand"
                  item-text="name"
                  item-value="id"
                  :items="brands"
                  :error-messages="errors"
                  :loading="loading_brands"
                  :disabled="loading || loading_brands"
                  clearable
                  return-object
                />
              </ValidationProvider>
              <ValidationProvider name="model" v-slot="{ errors }">
                <v-text-field
                  :label="$capitalize($tc('model.productbudget_model'))"
                  v-model="form.model"
                  name="model"
                  persistent-hint
                  :error-messages="errors"
                  :disabled="loading"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider name="description" v-slot="{ errors }">
                <v-text-field
                  :label="
                    $capitalize(
                      $tc('model.productbudget_additional_description')
                    )
                  "
                  v-model="form.description"
                  name="description"
                  persistent-hint
                  :error-messages="errors"
                  :disabled="loading"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider name="serial_number" v-slot="{ errors }">
                <v-text-field
                  :label="$capitalize($tc('model.productbudget_serial_number'))"
                  v-model="form.serial_number"
                  name="serial_number"
                  persistent-hint
                  :error-messages="errors"
                  :disabled="loading"
                ></v-text-field>
              </ValidationProvider>
            </v-card-text>
          </ValidationObserver>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="current_step = current_step - 1"
              v-if="!editMode"
              >{{ $capitalize($tc("model.productbudget_back_button")) }}</v-btn
            >
            <v-btn type="submit" color="primary" text>{{
              $capitalize($tc("model.productbudget_apply"))
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ScopeProvider from "@/components/ScopeProvider";

import { store as storeAttachment } from "@/services/attachment";
import { index as indexBrands } from "@/services/products/brands";
import { index as indexLocalCategories } from "@/services/products/local_categories";
import { autocompleteBarcode } from "@/services/products/products";
import { indexProducts } from "@/services/budgets";

export default {
  name: "product-form",
  props: ["product", "product_dialog"],
  data: function () {
    return {
      // Flags
      loading: false,
      loading_local_categories: false,
      loading_brands: false,
      loading_autocomplete_barcode: false,
      submitting: false,
      file_preview: false,

      // Filters
      filter_local_category: "",
      barcode: null,

      // Forms
      form_found_product: {
        id: null,
        brand: null,
        local_category: {
          id: "",
          name: "",
        },
        photo_url: "",
      },
      form: {
        barcode: null,
        brand: null,
        local_category: {
          id: null,
          name: "",
        },
        photo_url: "",
        report: {},
      },

      // Lists
      brands: [],
      local_categories: [],
      features: [],

      // Steps
      current_step: 1,
      steps: [
        {
          name: "barcode",
          title: this.$capitalize(this.$tc("model.marketplace_search_product")),
          editable: true,
        },
        {
          name: "local_category",
          title: this.$capitalize(this.$tc("model.marketplace_select_product")),
          editable: true,
        },
        {
          name: "product",
          title: this.$capitalize(
            this.$tc("model.marketplace_register_product")
          ),
          editable: true,
        },
      ],
    };
  },
  methods: {
    chooseLocalCategory(local_category) {
      this.form.local_category = local_category;
      this.current_step = this.current_step + 1;
    },
    async getProductByBarcode(barcode) {
      if (!barcode) return;

      this.resetFoundProduct();
      this.loading_autocomplete_barcode = true;
      try {
        const product = await autocompleteBarcode(barcode);
        this.form_found_product = {
          ...product,
          photo_url: product.product_photos
            ? product.product_photos[0]?.url
            : "",
          features: product.features ? product.features.slice(0, 5) : [],
        };
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: `Falha ao consultar por código de barras`,
          color: "red",
        });
      } finally {
        this.loading_autocomplete_barcode = false;
      }
    },
    async getLocalCategories() {
      this.loading_local_categories = true;
      try {
        const response = await indexLocalCategories({ list: true });
        this.local_categories = response;
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: `Falha ao carregar os tipos de produtos`,
          color: "red",
        });
      } finally {
        this.loading_local_categories = false;
      }
    },
    async getBrands() {
      this.loading_brands = true;
      try {
        const response = await indexBrands({ list: true });
        this.brands = response;
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: `Falha ao carregar as marcas do produto`,
          color: "red",
        });
      } finally {
        this.loading_brands = false;
      }
    },
    resetForm() {
      this.barcode = null;
      this.tab = 0;
      this.current_step = 1;
      this.form = {
        barcode: null,
        brand: "",
        local_category: {
          id: null,
          name: "",
        },
        photo_url: "",
        report: {},
      };
      this.resetFoundProduct();
    },
    handleClose() {
      this.resetForm();
      this.$emit("cancel");
    },
    async handleSubmitForm() {
      const validation = await this.$refs.form.validate();
      if (!validation) return;

      const local_category = this.form.local_category?.id
        ? this.form.local_category
        : {
            id: null,
            name: this.form.local_category,
          };

      const brand = this.form.brand?.id
        ? this.form.brand
        : {
            id: null,
            name: this.form.brand,
          };

      this.$emit("submit", {
        ...this.form,
        local_category_id: local_category.id,
        local_category_name: local_category.name,
        brand_id: brand.id,
        brand_name: brand.name,
      });
      this.handleClose();
    },
    showStep(name) {
      return this.availableSteps[this.current_step - 1]?.name == name;
    },
    nextStepAndSetProduct() {
      const product = this.form_found_product;

      if (product.brand?.name) this.form.brand = product.brand;

      if (product.local_category?.name)
        this.form.local_category = product.local_category;

      if (product.photo_url) this.photo_url = product.photo_url;

      if (product.features) this.features = product.features;

      this.form.id = product.id;
      this.form.barcode = this.barcode;
      this.form.model = product.model;
      this.form.photo_url = this.photo_url;

      this.current_step = this.current_step + 1;
    },
    resetFoundProduct() {
      this.form_found_product = {
        id: null,
        brand: null,
        local_category: null,
        photo_url: "",
      };
    },
    removeProduct() {
      this.resetFoundProduct();
      this.barcode = "";
    },
  },
  computed: {
    lead: function () {
      return this.$store.getters.getLead;
    },
    editMode: function () {
      return !!this.product.local_category_name;
    },
    foundProductName: function () {
      const name = [
        this.form_found_product.local_category?.name,
        this.form_found_product.brand?.name,
      ].join(" ");

      if (name.length > 59) return name.substr(0, 56) + "...";

      return name;
    },
    itemsPerLine: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 2;
        case "sm":
          return 3;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 4;
      }

      return 4;
    },
    chunked_categories: function () {
      const regex = new RegExp(this.filter_local_category?.toLowerCase(), "g");
      let filteredCategories = [];

      if (this.filter_local_category)
        filteredCategories = this.local_categories.filter((category) =>
          regex.test(category.name?.toLowerCase())
        );

      filteredCategories = this.local_categories;

      const groupsOfCategories = [];
      for (let i = 0; i < filteredCategories.length; i += this.itemsPerLine) {
        groupsOfCategories.push(
          filteredCategories.slice(i, i + this.itemsPerLine)
        );
      }

      return groupsOfCategories;
    },
    availableSteps: function () {
      if (this.form_found_product?.id)
        return this.steps.filter((step) => step.name != "local_category");

      return this.steps;
    },
  },
  created() {
    this.resetForm();
    this.form = {
      ...this.form,
      ...this.product,
    };

    this.getBrands();
    this.getLocalCategories();
  },
  watch: {
    product_dialog: function (value) {
      if (value)
        this.form = {
          ...this.form,
          ...this.product,
        };
    },
    barcode: function (value) {
      if (value && !this.editMode) this.getProductByBarcode(value);
    },
  },
};
</script>
